<template>
  <div>
    <div style="margin:10px 0;">
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableList"
      border
      class="table"
      highlight-current-row
      style="width: 100%;"
    >
      <!-- 档次名称列 -->
      <el-table-column align="center" label="影院分类名称" prop="name"/>

      <!-- 包含影院列 -->
      <el-table-column align="center" label="包含影院">
        <template slot-scope="{ row }">
          <el-link v-popover="`${row.id}-1`" type="primary">影院明细</el-link>
          <el-link v-popover="`${row.id}-2`" type="primary">影资编码</el-link>
          <span>（{{ row.cinemaNum }}家）</span>
          <!-- Popover for Resource Codes -->
          <el-popover
            :ref="row.id + '-2'"
            placement="bottom"
            trigger="click"
          >
            <div class="popover-content">
              {{ row.standardId }}
            </div>
          </el-popover>
          <!-- Popover for Cinema Details -->
          <el-popover
            :ref="row.id + '-1'"
            placement="bottom"
            trigger="click"
            width="400"
          >
            <div class="popover-content">
              {{ row.cinemaName }}
            </div>
          </el-popover>
        </template>
      </el-table-column>


      <!-- 状态列 -->
      <el-table-column align="center" label="状态">
        <template slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(row)"
          />
        </template>
      </el-table-column>

      <!-- 最后修改时间列 -->
      <el-table-column align="center" label="最后修改时间" prop="updateTime">
        <template slot-scope="{ row }">
          <span>{{ row.updateTime ? row.updateTime : row.createTime }}</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column align="center" label="操作">
        <template slot-scope="{ row }">
          <el-link type="primary" @click="editRow(row)">修改</el-link>
          <el-link type="danger" @click="deleteRow(row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗用于新增/修改影院档次 -->
    <dd-cinema-management-table-form-dialog
      :initial-data="currentRowData"
      :visible.sync="dialogVisible"
      @refreshData="refreshData"
    ></dd-cinema-management-table-form-dialog>
  </div>
</template>

<script>
import DdCinemaManagementTableFormDialog from "./ddCinemaManagementFormDialog.vue";
import mini from "@/api/mini";

const MiniModel = new mini();

export default {
  name: "ddCouponSynchronizationTable",
  components: {DdCinemaManagementTableFormDialog},
  props: {
    tableList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      currentRowData: {}, // 用于存储当前选中行的数据
    };
  },
  methods: {
    refreshData() {
      this.$emit("refreshData");
    },
    handleStatusChange(row) {
      // 处理状态切换，调用 dyCinemaStatus 方法
      console.log("状态已改变:", row.status, " - 档次名称:", row.name);
      MiniModel.dyCinemaStatus({
        id: row.id,
        status: row.status,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("状态更新成功");
            this.refreshData(); // 状态更新成功后刷新数据
          } else {
            this.$message.error("状态更新失败，请重试");
            // 恢复原有状态
            row.status = row.status === 1 ? 0 : 1;
          }
        })
        .catch((error) => {
          console.error("状态更新失败:", error);
          this.$message.error("状态更新失败，请重试");
          // 恢复原有状态
          row.status = row.status === 1 ? 0 : 1;
        });
    },
    handleAdd() {
      // 点击新增按钮时，重置 currentRowData，并打开弹窗
      this.currentRowData = {}; // 重置为新增状态
      this.dialogVisible = true; // 打开弹窗
    },
    editRow(row) {
      // 修改档次
      console.log("修改档次:", row);
      // 设置当前选中行数据为 currentRowData，并打开弹窗
      this.currentRowData = {...row}; // 使用扩展运算符来克隆对象，避免直接修改原始数据
      this.dialogVisible = true; // 打开弹窗
    },
    async deleteRow(row) {
      // 删除档次
      this.$confirm(`确定删除【${row.name}】该条档次吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            // 调用删除接口
            MiniModel.dyCinemaDel({
              id: row.id,
            }).then((res) => {
              if (res.data.code === 200) {
                this.$message.success("档次删除成功");
                // 删除后刷新表格数据
                this.refreshData();
              } else {
                this.$message.error("删除失败，请重试");
              }
            });
          } catch (error) {
            console.error("删除失败:", error);
            this.$message.error("删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.table {
  width: 100%;
}

.popover-content {
  max-height: 200px; /* 限制高度，防止内容溢出 */
  overflow-y: auto; /* 当内容超出时，添加垂直滚动条 */
  padding-right: 10px; /* 防止滚动条遮挡内容 */
}

/* 单个影院和影资编码的项目样式 */
.cinema-item,
.resource-code-item {
  margin-bottom: 5px; /* 保持项目之间有间距 */
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ksCouponExchange/ddCinemaManagement/components/ddCinemaManagementTable.vue